import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { ExtensionType, extensions } from '@pixi/core';
var assetKeyMap = {
  loader: ExtensionType.LoadParser,
  resolver: ExtensionType.ResolveParser,
  cache: ExtensionType.CacheParser,
  detection: ExtensionType.DetectionParser
};
extensions.handle(ExtensionType.Asset, function (extension) {
  var ref = extension.ref;
  Object.entries(assetKeyMap).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      key = _ref2[0];
    return !!ref[key];
  }).forEach(function (_ref3) {
    var _ref$key$extension;
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      type = _ref4[1];
    return extensions.add(Object.assign(ref[key], {
      extension: (_ref$key$extension = ref[key].extension) !== null && _ref$key$extension !== void 0 ? _ref$key$extension : type
    }));
  });
}, function (extension) {
  var ref = extension.ref;
  Object.keys(assetKeyMap).filter(function (key) {
    return !!ref[key];
  }).forEach(function (key) {
    return extensions.remove(ref[key]);
  });
});